import React, { useMemo } from "react";

import { Item } from "../../components/Menu";
import { MenuItem } from "../../components/Menu";
import PropTypes from "prop-types";
import { UrlUtils } from "../../utils";
import { useCommunicationHandlers } from "../UsefulLinks";
import { useFeature } from "../../hooks/useFeature";
import { AppFeatures } from "../../constants/featureFlags";

export const SecondaryMenuHelp = ({ link, title }) => {
  const { handleOnlineHelp } = useCommunicationHandlers();
  const isCustomerRelationsActive = useFeature(AppFeatures.CUSTOMER_RELATIONS);

  const helpItem = useMemo(
    () =>
      new Item({
        URL: UrlUtils.getNativeLink(link),
        title,
        iconKey: "help",
        target: "_blank"
      }),
    [link, title]
  );

  return (
    <MenuItem
      item={helpItem}
      onClick={isCustomerRelationsActive ? handleOnlineHelp : undefined}
      dataTestId="uc-help"
    />
  );
};

SecondaryMenuHelp.propTypes = {
  link: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};
